import Vue from "vue";

declare module "vue/types/vue" {
  interface Vue {
    notyfy: {
      success: (message) => void;
      error: (message) => void;
    };
  }
}

Vue.prototype.notyfy = {
  success: message => {
    (window as any).notyfy({ text: message, type: "success", timeout: 3000 });
  },
  error: message => {
    (window as any).notyfy({ text: message, type: "error", timeout: 3000 });
  }
};
